import { s as d } from "./lit-element-6iugfgmM.js";
const r = /* @__PURE__ */ new Set(), l = new MutationObserver(() => {
  const i = document.documentElement.dir === "rtl" ? document.documentElement.dir : "ltr";
  r.forEach((s) => {
    s.setAttribute("dir", i);
  });
});
l.observe(document.documentElement, { attributes: !0, attributeFilter: ["dir"] });
const u = (i) => i.startManagingContentDirection !== void 0 || i.tagName === "SP-THEME";
class m extends (/* @__PURE__ */ function(s) {
  return class extends s {
    get isLTR() {
      return this.dir === "ltr";
    }
    hasVisibleFocusInTree() {
      const t = ((n = document) => {
        var a;
        let e = n.activeElement;
        for (; e != null && e.shadowRoot && e.shadowRoot.activeElement; ) e = e.shadowRoot.activeElement;
        const c = e ? [e] : [];
        for (; e; ) {
          const o = e.assignedSlot || e.parentElement || ((a = e.getRootNode()) == null ? void 0 : a.host);
          o && c.push(o), e = o;
        }
        return c;
      })(this.getRootNode())[0];
      if (!t) return !1;
      try {
        return t.matches(":focus-visible") || t.matches(".focus-visible");
      } catch {
        return t.matches(".focus-visible");
      }
    }
    connectedCallback() {
      if (!this.hasAttribute("dir")) {
        let t = this.assignedSlot || this.parentNode;
        for (; t !== document.documentElement && !u(t); ) t = t.assignedSlot || t.parentNode || t.host;
        if (this.dir = t.dir === "rtl" ? t.dir : this.dir || "ltr", t === document.documentElement) r.add(this);
        else {
          const { localName: n } = t;
          n.search("-") > -1 && !customElements.get(n) ? customElements.whenDefined(n).then(() => {
            t.startManagingContentDirection(this);
          }) : t.startManagingContentDirection(this);
        }
        this._dirParent = t;
      }
      super.connectedCallback();
    }
    disconnectedCallback() {
      super.disconnectedCallback(), this._dirParent && (this._dirParent === document.documentElement ? r.delete(this) : this._dirParent.stopManagingContentDirection(this), this.removeAttribute("dir"));
    }
  };
}(d)) {
}
m.VERSION = "1.7.0";
export {
  m as S
};
//# sourceMappingURL=Base-pdJ5fkYW.js.map
